import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

import { SharedService } from 'src/app/core/services/shared.service';

declare const UIkit: any;

@Component({
  selector: 'app-file-preview-modal',
  templateUrl: './file-preview-modal.component.html',
  styleUrls: ['./file-preview-modal.component.scss']
})
export class FilePreviewModalComponent implements OnInit {
  @Input() fileType: string;
  @Input() imgSrc: SafeResourceUrl;
  @Input() link: SafeResourceUrl;
  @ViewChild('modal', { static: true }) modal: ElementRef;

  constructor(private sharedService: SharedService) {}

  ngOnInit() {
    UIkit.modal('#file-preview-modal').show();

    UIkit.util.on('#file-preview-modal', 'hidden', this.sharedService.deleteModal.bind(this, this.modal));
  }
}
